// extracted by mini-css-extract-plugin
export default {"container":"paper-module__container__j5+Gd"};